import React, { createContext, useState, useContext } from "react";

// Create Context
const LoaderContext = createContext();

// Provider Component
export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  // Function to toggle loader visibility
  const showLoader = () => setIsLoading(true);

  const hideLoader = () =>
    setTimeout(function () {
      setIsLoading(false);
    }, 2000);

  return (
    <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};

// Custom Hook to use the Loader Context
export const useLoader = () => useContext(LoaderContext);